import {scrollTo} from "./scrollTo";

export function screening() {
  let
    duration = 400,
    win = $(window);

  $('.screening').on('click', '.round, .cancel', function (e) {
    e.preventDefault();

    let
      parent = $(e.delegateTarget),
      topBlock = parent.find('.screening-top'),
      bottomBlock = parent.find('.screening-bottom');

    if (parent.hasClass('open')) {
      parent.removeClass('open');
      topBlock.slideDown(duration);
      bottomBlock.slideUp(duration);
    } else {
      parent.addClass('open');
      topBlock.slideUp(duration);
      bottomBlock.slideDown(duration);
    }
  });

  $('.information .link').on('click', function (e) {
    let screeningTop = $('.screening').offset().top;
    e.preventDefault();
    $('.screening .round').trigger('click');
    scrollTo(screeningTop);
  });

  function loadScreening() {
    $('.screenings').on('click', '.loadmore', function (e) {

      let
        btn = $(this),
        cursSreenings = $(e.delegateTarget),
        paged = btn.attr('data-paged');

      $.ajax({
        url: ajaxvars.ajaxurl,
        beforeSend: function () {
          cursSreenings.addClass('load');
        },
        data: {
          action: 'load_screening',
          paged: paged
        },
        type: 'POST',
        success: function success(response) {
          if (response) {
            cursSreenings.find('.post-list').append(response.content);
            btn.parent().html(response.page);
            win.trigger('changeImageBlocks').trigger('changeAnimatedBlocks');
          }
        },
        complete: function () {
          cursSreenings.removeClass('load');
        }
      });
    });
  }

  loadScreening();
}


// WEBPACK FOOTER //
// ./assets/js/modules/screening.js